import {Component, ViewEncapsulation} from '@angular/core';
import {NavigateService} from 'ngx-satoris';
import {InactivityService} from '../../shared/services/inactivity.service';
import {ApiService} from '../../shared/services/api.service';
import {CartService} from 'src/app/shared/services/cart.service';

@Component({
  selector: 'app-standby-kiosk',
  templateUrl: './standby-kiosk.component.html',
  styleUrl: './standby-kiosk.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class StandbyKioskComponent {
  constructor(public nav: NavigateService, public api: ApiService, private inactivity: InactivityService, private cart: CartService) {
    this.inactivity.stopWatching();
  }

  onStandbyClick() {
    if(this.api.env.useGuichet) {;
      this.cart.startApplication(true)
      this.nav.to('visa-type');
    } else {
      this.nav.to('standby-desc-kiosk');
    }
  }
}
